import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';
import { Button } from 'src/shared/components/Button';
import { ThumbButton } from 'src/shared/components/ThumbButton';

import { changeSingleValueQuestionAnswer } from '../actions/surveysActions';
import { QuestionComponentBaseProps, SurveyBooleanQuestionAnswer } from '../models/surveys';
import { getProgramSurveySingleQuestionAnswer } from '../selectors/surveysSelectors';
import { QuestionHeader } from './QuestionHeader';

const ThumbsWrapper = styled.div({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
});

const ButtonsWrapper = styled.div({
    marginTop: '0.88rem',
    '& > *:first-child': {
        marginRight: '0.88rem',
    },
});

interface StateProps {
    answer: SurveyBooleanQuestionAnswer | undefined;
}

interface ActionsProps {
    changeSingleValueQuestionAnswer: typeof changeSingleValueQuestionAnswer;
}

interface Props extends QuestionComponentBaseProps, StateProps, ActionsProps {
    inputType?: string;
}

export class BooleanQuestionContainer extends React.PureComponent<Props> {
    public handleValueChange = (value: boolean) => () => {
        const { programId, surveyId, id } = this.props;

        this.props.changeSingleValueQuestionAnswer({
            programId,
            surveyId,
            question: id,
            value,
        });
    };

    public render(): JSX.Element {
        const { question, answer, inputType, readableIndex } = this.props;

        const content = answer && answer.data.content;

        return (
            <>
                {question && <QuestionHeader index={readableIndex} header={question} />}
                {inputType && inputType === 'thumbs' ? (
                    <ThumbsWrapper>
                        <ThumbButton
                            onClick={this.handleValueChange(true)}
                            highlighted={content === true}
                        />
                        <ThumbButton
                            onClick={this.handleValueChange(false)}
                            highlighted={content === false}
                            isDown
                        />
                    </ThumbsWrapper>
                ) : (
                    <ButtonsWrapper>
                        <Button
                            small
                            type={content === true ? 'accept' : 'cancel'}
                            onClick={this.handleValueChange(true)}
                        >
                            Yes
                        </Button>
                        <Button
                            small
                            type={content === false ? 'accept' : 'cancel'}
                            onClick={this.handleValueChange(false)}
                        >
                            No
                        </Button>
                    </ButtonsWrapper>
                )}
            </>
        );
    }
}

const mapStateToProps = (state: AppState, { programId, surveyId, id }: Props): StateProps => ({
    answer: getProgramSurveySingleQuestionAnswer(state, programId, surveyId, id) as
        | SurveyBooleanQuestionAnswer
        | undefined,
});

export const BooleanQuestion = connect<StateProps, ActionsProps>(mapStateToProps, {
    changeSingleValueQuestionAnswer,
})(BooleanQuestionContainer);
